import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { GenericMessage } from '@app/interfaces/globals';
import { catchError, map, share } from 'rxjs/operators';
import { IAccountInterface } from './account.interface';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AccountApi {
	constructor(private toasterService: WrapToasterService, private apiFacade: ApiFacadeService) {}

	public getAll(): Observable<IAccountInterface[]> {
		const url = 'frontend/account/get-accounts';

		const responseObservable = this.apiFacade.get<{ accounts: IAccountInterface[] }>(url).pipe(
			map((data) => data.accounts),
			catchError((error) => {
				this.toasterService.handleRequestFailed(error);
				return of([]);
			}),
			share(),
		);

		window.zestyHost.sharedResponsePromisesByUrl[url] = responseObservable.toPromise();
		return responseObservable;
	}

	public renameAccount(account: IAccountInterface): Observable<GenericMessage> {
		const url = 'frontend/organization/rename-account';
		const payload = {
			account_id: account.id,
			account_name: account.alias,
		};

		return this.apiFacade.post(url, payload).pipe(
			catchError((error) => {
				this.toasterService.handleErrorMessage(
					'Failed to save account name. Please make sure no special characters used in account name',
				);
				return of(error);
			}),
		);
	}
}
